import * as Sentry from '@sentry/react';

/**
 * Send a custom error to Sentry
 * @param error - Error object or error message
 * @param context - Optional additional context data
 * @param level - Optional severity level (default: 'error')
 */
export const sendSentryError = (
  error: Error | string,
  context?: Record<string, unknown>,
  level: Sentry.SeverityLevel = 'error'
): void => {
  const errorObject = typeof error === 'string' ? new Error(error) : error;

  Sentry.withScope(scope => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
    }

    scope.setLevel(level);
    Sentry.captureException(errorObject);
  });
};

/**
 * Send a custom message to Sentry
 * @param message - Message to send
 * @param context - Optional additional context data
 * @param level - Optional severity level (default: 'info')
 */
export const sendSentryMessage = (
  message: string,
  context?: Record<string, unknown>,
  level: Sentry.SeverityLevel = 'info'
): void => {
  Sentry.withScope(scope => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
    }

    scope.setLevel(level);
    Sentry.captureMessage(message);
  });
};
